import { observer } from 'mobx-react';
import useAsyncEffect from 'use-async-effect';
import { useNavigate, useParams, } from 'react-router-dom';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import { Button } from '../../../../core/components/Index';
import SpcSidebarStatic from './SpcSidebarStatic';
import SavedEstimates from './SavedEstimates';

const SpcSavedEstimates = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  vm.navigate = useNavigate();
  let { memberId } = useParams();

  useAsyncEffect(async () => {
    await vm.getSavedEstimates(memberId);
  }, []);

  return (
    <>
      <div className=" px-6 lg:px-12 py-4 space-y-6 my-4">
        <div className="flex flex-wrap md:flex-nowrap">
          <SpcSidebarStatic />
        <div className="max-w-full max-w-[1000px]" id="content">
            <div className="max-w-full max-w-[860px]">
              <h1 className="text-32px tracking-[-1%] text-[#363636] font-semibold mb-[40px]">Your Saved Estimates</h1>
              <p className='text-15px mb-[32px] tracking-[-1.5%]'>You have one or more saved estimates. Select an estimate below to review, print, or update, or click Begin New Estimate to start fresh.</p>
              <div className="max-w-[90vw] overflow-auto">
                <SavedEstimates />
              </div>
              <div className="flex mt-[32px] flex-wrap gap-2 sm:flex-nowrap">
                <Button
                    className="border border-[#345719] bg-[#557122]"
                    label="Begin New Estimate"
                    rounded
                    onClick={async () => {
                      await vm.beginNewEstimate(memberId!);  
                    }}
                  />
              </div>
            </div>
          </div>
        </div> 
      </div>
    </>
  );
});

export default SpcSavedEstimates;
